export default __webpack_public_path__ + "static/media/Stud Labs Full.77b513ec.png";